import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

import { useMemo } from "react";
import MaterialReactTable from "material-react-table";
import { Edit } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import { obtenerTodosEstados } from "../Services/Rest";

function InfoEstados(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
      method: "get",
      url: obtenerTodosEstados,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);

  const grupos = ["A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8", "A9", "A10"];
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        filterVariant: "text",
        enableEditing: false,
      },

      {
        accessorKey: "estado",
        header: "Estado",
        filterVariant: "text",
        enableEditing: true,
      },
    ],
    []
  );
  const [tableData, setTableData] = useState(() => list);
  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    axios({
      method: "put",
      url:
        "https://suadesarrollo.azurewebsites.net/api/ActualizaTarea?Id=" +
        values.id,
      data: values,
    })
      .then((Response) => {
        console.log(Response.data);
        alert("Actualizado con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al Actualizar" + error);
      });

    //send/receive api updates here
    setTableData([...tableData]);
    exitEditingMode(); //required to exit editing mode
    console.log("post data ");
    console.log(values.id);
  };
  return (
    <div>
      <div className="test">
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Tareas Asiganadas
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <MaterialReactTable
                      columns={columns}
                      data={list}
                      enableMultiRowSelection={true}
                      editingMode="modal"
                      enableColumnOrdering
                      enableEditing
                      onEditingRowSave={handleSaveRow}
                      renderRowActions={({ row, table }) => (
                        <Box sx={{ display: "flex", gap: "1rem" }}>
                          <Tooltip arrow placement="left" title="Edit">
                            <IconButton
                              onClick={() => table.setEditingRow(row)}
                            >
                              <Edit />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default InfoEstados;
